export default function AnimateHero() {
  const wrapper = document.querySelectorAll<HTMLElement>(".js-animate-wrapper");

  if (wrapper) {
    const handleCreateLineSplit = () => {
      wrapper.forEach((el) => {
        const items = el.querySelectorAll<HTMLElement>(".js-animate-text");

        items.forEach((item) => {
          const containerWidth = item.offsetWidth;

          if (item) {
            const text = item.innerText;
            const styles = window.getComputedStyle(item);
            const string = document.createElement("span");
            const words = text.split(" ");
            const lines = [];
            let currentLine = "";

            string.style.visibility = "hidden";
            string.style.whiteSpace = "nowrap";
            string.style.font = styles.font;

            document.body.appendChild(string);

            words.forEach((word) => {
              const testLine = currentLine ? currentLine + " " + word : word;
              string.textContent = testLine;

              if (string.offsetWidth > containerWidth) {
                lines.push(currentLine);
                currentLine = word;
              } else {
                currentLine = testLine;
              }
            });

            if (currentLine) {
              lines.push(currentLine);
              item.innerText = "";
              item.style.opacity = "1";
            }

            lines.forEach((line) => {
              const span = document.createElement("span");
              span.className = "js-animate-line animate";
              span.textContent = line;

              item.appendChild(span);
            });

            document.body.removeChild(string);

            window.addEventListener("resize", () => {
              item.textContent = text;
            });
          }
        });
      });
    };

    const handleInitAnimation = () => {
      wrapper.forEach((el) => {
        const animateItems = el.querySelectorAll<HTMLElement>(".js-animate-line, .js-animate-section");
        const renderDelay = 300;

        animateItems.forEach((item, index) => {
          let delay = renderDelay * index;

          setTimeout(() => {
            item.classList.add("is-visible");
          }, delay);
        });
      });
    };

    document.fonts.ready.then(() => {
      handleCreateLineSplit();
      handleInitAnimation();
    });
  }
}
